<template>
  <AppBar title="Home">
    <v-btn :to="{ name: '/login' }">accounts</v-btn>
  </AppBar>
  <Home />
</template>
